import { render } from "./PersonalInfo.vue?vue&type=template&id=521d1434"
import script from "./PersonalInfo.vue?vue&type=script&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&lang=js"
script.render = render

export default script